module.exports = "<div class=\"c-image\">\n  <div class=\"c-image__img\" ng-style=\"vm.getImage()\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/content-types/image/image.html
// module id = 407
// module chunks = 0